module.exports = __webpack_public_path__ + "img/Frame 750.0554bd72.png";